export default __webpack_public_path__ + "static/media/Erik Sussman.652ef269.jpg";